<h2 mat-dialog-title>
  <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#token-s"></use></svg>
  Rediger brikker
</h2>
<button type="button" class="btn-close btn-icon" mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>

<mat-dialog-content>
  <div class="form-row form-row--multi-select nolimits">
    <div class="id-tag-header"></div>
    @if (!hasCompanyCar && !chargingUser.invoicingAccountNumber && companyCarDetermined) {
      <div class="feedback-row">
        <ok-feedback-fail>
          Da kunden ikke har firmabil skal G4 Kontonr. udfyldes og gemmes inden der kan tilføjes brikker til kunden.
        </ok-feedback-fail>
      </div>
    }

    @if (hasCompanyCar && !chargingUser.agreementNumber) {
      <div class="feedback-row">
        <ok-feedback-fail>
          Da kunden har firmabil skal G4 Aftalenr. udfyldes og gemmes inden der kan tilføjes brikker til kunden.
        </ok-feedback-fail>
      </div>
    }

    @if (!hasDeliveryAddress && companyCarDetermined) {
      <div class="feedback-row">
        <ok-feedback-fail>
          <div>
            <strong>En leveringsadresse er påkrævet for at oprette en brik</strong>
            <br />
            <span>Hvis brugeren har firmabil er det typisk brugerens afdeling, der bruges som leveringsadresse.</span>
            <br />
            <span>Hvis brugeren ikke har firmabil skal leveringsadressen være indtastet på brugeren</span>
          </div>
        </ok-feedback-fail>
      </div>
    }
    @if (!organizationHasIdTagGroup) {
      <div class="feedback-row">
        <ok-feedback-fail>
          Der er ikke tilknyttet en id tag gruppe til brugerens organisation. Derfor kan man ikke oprette brikker til denne bruger.
        </ok-feedback-fail>
      </div>
    }
    @if (!organizationHasIdTagGroup && idTags().length > 0) {
      <div class="feedback-row">
        <ok-feedback-info>
          Nedenstående brikker kan ikke starte en ladning, på organisationens ladestandere. Kontakt IT for hjælp.
        </ok-feedback-info>
      </div>
    }
    @if (!companyCarDetermined) {
      <div class="feedback-row">
        <ok-feedback-fail>
          Da der ikke er taget stilling til om brugeren har firmabil eller ej, kan der ikke tilknyttes brikker til brugeren
          <button type="button" mat-flat-button color="primary" (click)="openEditUserModal(chargingUser)" style="white-space: nowrap">
            Rediger bruger
          </button>
        </ok-feedback-fail>
      </div>
    }
    @if (!chargingUserHasDepartment) {
      <div class="feedback-row">
        <ok-feedback-fail>Brugeren har ingen afdeling tilknyttet.</ok-feedback-fail>
      </div>
    }
    @if (
      hasDeliveryAddress &&
      (hasCompanyCar || chargingUser.invoicingAccountNumber) &&
      (!hasCompanyCar || chargingUser.agreementNumber) &&
      companyCarDetermined &&
      chargingUserHasDepartment &&
      (organizationHasIdTagGroup || idTags().length > 0)
    ) {
      <div class="multi-select">
        <div class="multi-select__list multi-select__list--grid">
          <div class="multi-select__headers">
            <div class="multi-select__item--status">
              <strong>Status</strong>
            </div>
            <div class="multi-select__item--name">
              <strong>Beskrivelse</strong>
            </div>
            <div class="multi-select__item--discount">
              <strong>Brik ID</strong>
            </div>
            <div class="multi-select__item--discount">
              <strong>RFID</strong>
            </div>
            <div></div>
            <div></div>
          </div>

          @for (idTag of idTags(); track idTag.id; let i = $index) {
            <div class="multi-select__item multi-select__item--tall">
              <div class="multi-select__item-title padding--left-none">
                @if (idTag.status.toString() === idTagStatusEnum[idTagStatusEnum.Pending]) {
                  <svg [matTooltip]="'Afventer behandling'" class="icon-24">
                    <use href="assets/images/ok-icons-sprite.svg#state-waiting"></use>
                  </svg>
                }
                @if (idTag.status.toString() === idTagStatusEnum[idTagStatusEnum.Active]) {
                  <svg [matTooltip]="'Aktiv'" class="icon-24"><use href="assets/images/ok-icons-sprite.svg#state-available"></use></svg>
                }
                @if (idTag.status.toString() === idTagStatusEnum[idTagStatusEnum.Inactive]) {
                  <svg [matTooltip]="'Inaktiv'" class="icon-24">
                    <use href="assets/images/ok-icons-sprite.svg#state-paused"></use>
                  </svg>
                }
                @if (idTag.status.toString() === idTagStatusEnum[idTagStatusEnum.NoIdTagGroup]) {
                  <svg [matTooltip]="'Adgang fjernet'" class="icon-24">
                    <use href="assets/images/ok-icons-sprite.svg#state-deactivated"></use>
                  </svg>
                }
                @if (idTag.status.toString() === idTagStatusEnum[idTagStatusEnum.Blocked]) {
                  <svg [matTooltip]="'Spærret'" class="icon-24"><use href="assets/images/ok-icons-sprite.svg#state-faulted"></use></svg>
                }
              </div>
              <div class="multi-select__item-title">
                <span>&nbsp;{{ idTag.description }}</span>
              </div>
              <div class="multi-select__item-title">
                <span>&nbsp;{{ idTag.printedId }}</span>
              </div>
              <div class="multi-select__item-title">
                <span>&nbsp;{{ idTag.idToken }}</span>
              </div>
              <button
                mat-icon-button
                class="delete"
                title="Fjern"
                type="button"
                (click)="deleteIdTag(idTag)"
                [disabled]="idTag.status.toString() !== idTagStatusEnum[idTagStatusEnum.Active]">
                <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#trash-s"></use></svg>
              </button>
            </div>
          }
          @if (organizationHasIdTagGroup) {
            <div class="multi-select__input">
              <form [formGroup]="idTagFormGroup" autocomplete="off" class="nolimits">
                <mat-form-field>
                  <mat-label>Brik ID</mat-label>
                  <input
                    type="text"
                    required=""
                    placeholder="Brikkens ID..."
                    matInput
                    [matAutocomplete]="auto"
                    formControlName="printedId"
                    maxlength="6" />

                  <mat-autocomplete
                    #auto="matAutocomplete"
                    (optionSelected)="selectIdTag($event.option.value)"
                    okCustomDropDownArrowDirective>
                    @for (option of filteredLookupIdTags; track option.printedId) {
                      <mat-option [value]="option.printedId">
                        {{ option.printedId }}
                      </mat-option>
                    }
                  </mat-autocomplete>
                  <mat-icon matSuffix></mat-icon>
                  <mat-hint>{{ queriedPrintedId?.toString()?.length || 0 }}/6 cifre</mat-hint>

                  <mat-error>
                    @if (printedId.errors?.['printedIdAlreadyUsed']) {
                      Brik ID {{ queriedPrintedId }} er optaget
                    }
                    @if (printedId.errors?.['foundNoPrintedIds']) {
                      Der blev ikke fundet nogen brik ID'er
                    }
                    @if (printedId.errors?.['required'] || printedId.errors?.['pattern']) {
                      Brikkens ID består af et tal mellem 1 og 6 cifre
                    }
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>RFID</mat-label>
                  <input matInput placeholder="RFID" formControlName="idToken" value="" [disabled]="true" readonly />
                  @if (idTagFormGroup.controls['idToken'].invalid) {
                    <mat-error [innerHTML]="getErrorMessage('idToken')"></mat-error>
                  }
                </mat-form-field>

                <button
                  mat-flat-button
                  color="primary"
                  title="Tilføj"
                  (click)="createIdTag()"
                  class="add-button"
                  [disabled]="savingIdTag || idTagFormGroup.invalid"
                  [class.spinner]="savingIdTag">
                  <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#plus-s"></use></svg>
                </button>
              </form>
            </div>
          }
        </div>
      </div>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button type="button" mat-button (click)="close()">Luk</button>
</mat-dialog-actions>
